module.exports = __webpack_public_path__ + "img/MCK55W.5c9e0ef6.png";